<template>
  <b-tab>
    <template v-slot:title>Membership Fees</template>
    <div>

      <!-- Major Permissions -->
      <h4 class="text-black">View Membership Fees</h4>
      <div class="mb-2 border-bottom row" v-for="(item, index) in permissions" :key="index">
        <div class="col-2">{{ item.rolename }}</div>
        <div class="col">
          <RockerSwitch v-if="item.view_membershipfees == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'view_membershipfees')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'view_membershipfees')" />
        </div>
      </div>

      <div>
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-2">Add New Fees</div>
          <div class="col-2">Approve Fees</div>
          <div class="col-2">Edit Fees</div>
          <div class="col-3">Delete Fees</div>
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- New Membership Fees -->
          <div class="col-2">
            <RockerSwitch v-if="item.new_membershipfees == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'new_membershipfees')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'new_membershipfees')" />
          </div>

          <!-- Approve Membership Fees -->
          <div class="col-2">
            <RockerSwitch v-if="item.approve_membershipfees == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'approve_membershipfees')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'approve_membershipfees')" />
          </div>

          <!-- Edit Membership Fees -->
          <div class="col-2">
            <RockerSwitch v-if="item.edit_membershipfees == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'edit_membershipfees')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'edit_membershipfees')" />
          </div>

          <!-- Delete Member -->
          <div class="col-2">
            <RockerSwitch v-if="item.delete_membershipfees == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'delete_membershipfees')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'delete_membershipfees')" />
          </div>

        </div>
      </div>
    </div>
  </b-tab>
</template>

<script>
import axios from "axios";
import RockerSwitch from "vue-rocker-switch";
import "vue-rocker-switch/dist/vue-rocker-switch.css";
import appConfig from "@/app.config";
import { permissionMethods } from "@/state/helpers";

export default {
  name: "FeePermissions",
  page: {
    title: "System Permissions",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  props: {
    permissions: Array,
  },
  components: {
    RockerSwitch
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Permissions",
      items: [{ text: "Dashboard", to: "/", }, { text: "System Permissions", active: true, },],
      isBusy: true,
      role: '',
      permission: '',
    };
  },
  computed: {
    filteredPermissions() {
      return this.permissions.filter((permission) => permission.view_membershipfees == 1);
    },
  },
  methods: {
    ...permissionMethods,
    async changePermission(role, permission) {
      this.role = role;
      this.permission = permission;
      let formData = new FormData();
      formData.append("role", this.role);
      formData.append("permission", this.permission);
      let url = "/updatepermission";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPermissions();
          this.role = "";
          this.permission = "";
        }
      });
    },
  },
};
</script>